var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertWorkArrowup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 10,
    viewBox: "0 0 34 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.943956 8.70582C1.33464 8.89329 1.86445 8.99861 2.41687 8.99861C2.9693 8.99861 3.49911 8.89329 3.88979 8.70582L17.0002 2.41282L30.1106 8.70582C30.3028 8.80133 30.5327 8.87751 30.7869 8.92992C31.041 8.98233 31.3144 9.00992 31.591 9.01107C31.8677 9.01222 32.142 8.98692 32.398 8.93664C32.6541 8.88636 32.8867 8.81211 33.0823 8.71821C33.2779 8.62432 33.4326 8.51267 33.5373 8.38977C33.6421 8.26688 33.6948 8.1352 33.6924 8.00242C33.69 7.86964 33.6325 7.73842 33.5233 7.61642C33.4141 7.49441 33.2554 7.38407 33.0565 7.29182L18.4731 0.29182C18.0824 0.104348 17.5526 -0.000966072 17.0002 -0.000966072C16.4478 -0.000966072 15.918 0.104348 15.5273 0.29182L0.943956 7.29182C0.553392 7.47935 0.333984 7.73366 0.333984 7.99882C0.333984 8.26398 0.553392 8.51829 0.943956 8.70582Z",
    fill: "#02E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertWorkArrowup);
export default __webpack_public_path__ + "static/media/note-expert-work-arrowup.ad58f5586e537b817efc2757fd6caa6e.svg";
export { ForwardRef as ReactComponent };